// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"255":"9e7d8b92","787":"7ba370de"}[chunkId] + ".chunk.js";
};